'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'

import { URLS } from '@/configs/urls'
import Button from '@/shared/ui/Button'

import S from '../ErrorStates.module.scss'

const ClubNotFound = () => {
  const t = useTranslations('club.notFound')
  return (
    <div className={S.state}>
      <h2 className={S.title}>{t('title')}</h2>
      <p className={S.description}>{t('description')}</p>
      <Link href={URLS.CLUBS}>
        <Button color="color">{t('backToClubs')}</Button>
      </Link>
    </div>
  )
}

export default ClubNotFound
